"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsableTable = CollapsableTable;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _BodyRow = require("../body-row/BodyRow");
var _classnames = _interopRequireDefault(require("classnames"));
var _cells = require("../cells");
var _TableWidthMeasure = require("../table-width-measure/TableWidthMeasure");
var _collapsableTableModule = _interopRequireDefault(require("./collapsable-table.module.scss"));
var _reactAccessibleAccordion = require("react-accessible-accordion");
var _useHover2 = require("./hooks/useHover");
var ROW_HEIGHT = 48;
function CollapsableTable(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    testId = _ref.testId,
    noResultsComponent = _ref.noResultsComponent,
    onRowClick = _ref.onRowClick,
    innerRef = _ref.innerRef,
    horizontalScrollWidth = _ref.horizontalScrollWidth,
    SectionHeader = _ref.SectionHeader,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 0 : _ref$pageSize,
    _ref$BodyRowComponent = _ref.BodyRowComponent,
    BodyRowComponent = _ref$BodyRowComponent === void 0 ? _BodyRow.BodyRow : _ref$BodyRowComponent,
    getInfiniteScrollSentry = _ref.getInfiniteScrollSentry;
  var _useHover = (0, _useHover2.useHover)(data),
    isHovered = _useHover.isHovered,
    onMouseEnterFactory = _useHover.onMouseEnterFactory,
    onMouseLeaveFactory = _useHover.onMouseLeaveFactory;
  return /*#__PURE__*/_react.default.createElement(_TableWidthMeasure.TableWidthMeasure, null, function (_ref2) {
    var measureRef = _ref2.measureRef,
      width = _ref2.width;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_collapsableTableModule.default['collapsable-table'], (0, _defineProperty2.default)({}, _collapsableTableModule.default['collapsable-table--overflow'], width < horizontalScrollWidth)),
      ref: measureRef
    }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.Accordion, {
      allowZeroExpanded: true,
      allowMultipleExpanded: true,
      preExpanded: data.map(function (_, index) {
        return index;
      })
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: _collapsableTableModule.default['collapsable-table__container'],
      style: {
        minWidth: horizontalScrollWidth
      },
      "data-testid": testId,
      ref: innerRef
    }, /*#__PURE__*/_react.default.createElement("thead", {
      className: _collapsableTableModule.default['collapsable-table__head']
    }, /*#__PURE__*/_react.default.createElement("tr", {
      className: _collapsableTableModule.default['collapsable-table__header-row']
    }, columns.map(function (c) {
      var HeaderCell = c.component ? c.component.Header : _cells.TextCell.Header;
      return /*#__PURE__*/_react.default.createElement(HeaderCell, {
        key: c.name
      }, c.name);
    }))), /*#__PURE__*/_react.default.createElement("tbody", {
      className: _collapsableTableModule.default['collapsable-table__accordions-container']
    }, data.map(function (rows, sectionIndex) {
      var displayPlaceholders = rows === undefined;
      var rowData = rows || Array(pageSize).fill(undefined);
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: sectionIndex,
        className: _collapsableTableModule.default['collapsable-table__accordion-row']
      }, /*#__PURE__*/_react.default.createElement("td", {
        className: _collapsableTableModule.default['collapsable-table__accordion-cell']
      }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItem, {
        uuid: sectionIndex
      }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemState, null, function (_ref3) {
        var expanded = _ref3.expanded;
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemHeading, null, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemButton, null, /*#__PURE__*/_react.default.createElement("div", {
          className: _collapsableTableModule.default['collapsable-table__item-header']
        }, /*#__PURE__*/_react.default.createElement(SectionHeader, {
          expanded: expanded,
          index: sectionIndex
        })))), /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemPanel, {
          style: pageSize ? {
            maxHeight: pageSize * ROW_HEIGHT,
            overflow: 'auto'
          } : undefined
        }, /*#__PURE__*/_react.default.createElement("table", {
          className: _collapsableTableModule.default['collapsable-table__accordion-items-container'],
          "data-testid": "table-section-".concat(sectionIndex)
        }, /*#__PURE__*/_react.default.createElement("tbody", {
          className: _collapsableTableModule.default['collapsable-table__accordion-items']
        }, displayPlaceholders || rows.length !== 0 ? rowData.map(function (row, dataIndex) {
          var key = row === undefined ? dataIndex : row.id;
          return /*#__PURE__*/_react.default.createElement(BodyRowComponent, {
            key: key,
            row: row,
            onClick: onRowClick,
            onMouseEnter: onMouseEnterFactory(sectionIndex, dataIndex),
            onMouseLeave: onMouseLeaveFactory(sectionIndex, dataIndex)
          }, columns.map(function (column, index) {
            var Cell = column.component || _cells.TextCell;
            if (row === undefined) {
              return /*#__PURE__*/_react.default.createElement(Cell.Loading, {
                key: index
              });
            }
            return /*#__PURE__*/_react.default.createElement(Cell, {
              row: row,
              key: column.accessor.toString(),
              data: row[column.accessor],
              hovered: isHovered(sectionIndex, dataIndex)
            });
          }));
        }) : noResultsComponent)), !displayPlaceholders && getInfiniteScrollSentry && getInfiniteScrollSentry(sectionIndex)));
      }))));
    })))));
  });
}